import Api from '@/services/api';

export default {
  get(id) {
    return Api().get("/bce/" + id);
  },
  getPublications(id) {
    return Api().get("/publications/" + id);
  },
  synchronizeNbb(tva) {
    return Api().get('/nbb/' + tva);
  }
};